import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-[#1A1A1A] text-[#FFF8F0] py-12 px-4 mt-auto" data-id="element-275">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8 text-center md:text-left" data-id="element-276">
        <div className="space-y-2" data-id="element-277">
          <h3 className="font-serif text-xl text-[#C5A55A]" data-id="element-278">
            Top Notch Bakery
          </h3>
          <p className="text-sm opacity-80" data-id="element-279">Est. 2021</p>
        </div>

        <div className="flex flex-col gap-3 text-sm opacity-90" data-id="element-280">
          <a href="https://maps.google.com/?q=Klostergatan+7,+Växjö" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#C5A55A] transition-colors" data-id="element-281">
            <MapPinIcon className="h-4 w-4 text-[#C5A55A]" data-id="element-282" />
            <span data-id="element-283">Klostergatan 7, Växjö</span>
          </a>
          <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-284">
            <PhoneIcon className="h-4 w-4 text-[#C5A55A]" data-id="element-285" />
            <span data-id="element-286">0470-52 36 03</span>
          </div>
          <a href="mailto:order@topnotchbakery.se" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#C5A55A] transition-colors" data-id="element-287">
            <MailIcon className="h-4 w-4 text-[#C5A55A]" data-id="element-288" />
            <span data-id="element-289">order@topnotchbakery.se</span>
          </a>
        </div>

        <div className="text-xs opacity-50" data-id="element-290">
          &copy; {new Date().getFullYear()} Top Notch Bakery.
        </div>
      </div>
    </footer>;
}